import type {Optional} from '@yandex-delivery/types'
import {allPass, applySpec, flow, get, ifElse, isString, isUndefined, pipe, toUndefined} from '@yandex-delivery/utils'

import type {DeliveryInterval, LikeDeliveryInterval, SddDeliveryInterval, SearchedSddClaim} from 'src/shared/types'

import {convertToStandardDate} from './convert-to-standard-date'

// --- Checks if the delivery interval is valid ---
export const isValidDeliveryInterval = (likeInterval?: LikeDeliveryInterval): likeInterval is DeliveryInterval =>
  pipe(likeInterval, allPass([flow(get('from'), isString), flow(get('to'), isString)]))

export const toDeliveryDate = (sddClaim?: SearchedSddClaim): Optional<string> => {
  const fromClaim = get('same_day_data.delivery_interval.from', sddClaim)

  return fromClaim ? convertToStandardDate(fromClaim) : undefined
}

// --- Extracts delivery interval from the claim data ---
const extractDeliveryIntervalFromClaim: (deliveryInterval?: SddDeliveryInterval) => DeliveryInterval =
  applySpec<DeliveryInterval>({
    from: get('from'),
    to: get('to'),
  })

export const toDeliveryInterval: (sddClaim?: SearchedSddClaim) => Optional<DeliveryInterval> = flow(
  get('same_day_data.delivery_interval'),
  ifElse(isUndefined, toUndefined, extractDeliveryIntervalFromClaim),
)
